import { computed, getCurrentInstance, type Ref, unref } from 'vue'
import { ACTIVE, CANCELLED, COMPLETED, PAUSED } from '@/models/job'

// A composable function to handle navigation for job side sheet
// When a user navigates in the job list or day view and clicks on a job row,
// it will open the job side sheet and update the URL accordingly.
// In this scenario:
// mainRouteName: the name of the parent route ('job-search' for Jobs list, 'day-view' for Day view, etc.)
// detailRouteName: the name of the route that renders the job sidesheet
// ('search-ticket-info-panel' when job sidesheet is rendered in the jobs list,
// 'sv-ticket-info-panel' when job sidesheet is in day view)
export function useJobSideSheetNavigation(
  mainRouteName: string | Ref<string>,
  detailRouteName: string | Ref<string>,
) {
  const inst = getCurrentInstance()
  const selectedJobNumber = computed(() => inst?.proxy.$route.params.id || '')
  const isRightDrawerVisible = computed(() => inst?.proxy.$route.name !== unref(mainRouteName))
  const handleRowClicked = async (item) => {
    inst?.proxy.$router.push({
      name: unref(detailRouteName),
      params: { id: item.number },
    })
  }

  return {
    selectedJobNumber,
    handleRowClicked,
    isRightDrawerVisible,
  }
}

export function useBatchSideSheetNavigation(mainRouteName: string, detailRouteName: string) {
  const inst = getCurrentInstance()
  const selectedBatchId = computed(() => inst?.proxy.$route.params.batchId || '')
  const isRightDrawerVisible = computed(() => inst?.proxy.$route.name !== mainRouteName)
  const handleRowClicked = async (item) => {
    inst?.proxy.$router.push({
      name: detailRouteName,
      params: { batchId: item.id },
    })
  }

  return {
    selectedBatchId,
    handleRowClicked,
    isRightDrawerVisible,
  }
}

export const ALLOWED_JOB_STATUS_FOR_READONLY_UI = [COMPLETED, ACTIVE, PAUSED, CANCELLED]
